import { initVideoPlayers } from '@sts/components/ui/Video/view';

const init = () => {
    initVideoPlayers(document);
};

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
